import { get } from 'lodash'
import { isNonEmptyNumber } from '@labrav/common'
import { ContractDurationType, DiscountType } from '../../../../types/flyout'
import type { ReceivedResellerAuthorization } from '../../../../modules/receivedResellerAuthorization/reducer'
import { getPricesArray } from '../../../../modules/resaleAuthorization/utils/getPricesArray'
import { priceMappingWithAll } from '../../../FreeTrialLabraUI/Dimensions/Dimensions.constants'

export const getContractDuration = (
  resellerAuthorization?: ReceivedResellerAuthorization
) => {
  const duration = resellerAuthorization?.contractDurationInMonthsForEndCustomer

  if (
    isNonEmptyNumber(duration) &&
    (resellerAuthorization?.contractDurationType ===
      ContractDurationType.CUSTOM ||
      resellerAuthorization?.discountType ===
        DiscountType.FLEXIBLE_PAYMENT_TERMS)
  ) {
    return {
      tooltipValue: '',
      durationValue: `${duration} month${duration! > 1 ? 's' : ''}`,
    }
  }

  const priceValue = getPricesArray(resellerAuthorization?.dimensions || [])

  if (priceValue?.length === 1) {
    return {
      tooltipValue: '',
      durationValue: get(priceMappingWithAll, priceValue[0]).toLowerCase(),
    }
  }

  if (priceValue.length > 1) {
    const multiPriceTooltip = priceValue
      ?.map(
        (item, index) =>
          `${get(priceMappingWithAll, item).toLowerCase()}${
            priceValue?.length > 3 && index + 1 === priceValue?.length - 1
              ? ' or'
              : ''
          }`
      )
      .join(', ')
    return {
      tooltipValue: multiPriceTooltip,
      durationValue: 'Standard',
    }
  }
  return {
    tooltipValue: '',
    durationValue: '-',
  }
}
